import MessageInputComponent from "./MessageInputComponent";

export default MessageInputComponent;
